import React, { useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import InstanciasTabla from '../elementos/InstanciasTabla';
import InstanciaCategoria from '../elementos/InstanciaCategoria';

export default function Instancias({ dataList }) {

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode;

    return (
        dataList.map((elem, index) => {
            return (
                elem.tipo === "item" ?
                    <InstanciasTabla key={index} elem={elem} />
                    :
                    elem.tipo === "categoria" ?
                        <InstanciaCategoria key={index} elem={elem.hijos} />
                        :
                        <></>
            )
        })
    )
}